import { render, staticRenderFns } from "./TablePage.vue?vue&type=template&id=35016b2e&scoped=true&"
import script from "./TablePage.vue?vue&type=script&lang=js&"
export * from "./TablePage.vue?vue&type=script&lang=js&"
import style0 from "./TablePage.vue?vue&type=style&index=0&id=35016b2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35016b2e",
  null
  
)

export default component.exports